module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Regular.76e68770.woff";